import { render, staticRenderFns } from "./ConsumeTypeInfoCard.vue?vue&type=template&id=73c18a2f&scoped=true&"
import script from "./ConsumeTypeInfoCard.vue?vue&type=script&lang=js&"
export * from "./ConsumeTypeInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c18a2f",
  null
  
)

export default component.exports